import * as React from 'react';
import { useAffirm, useModalSettingsContext, usePostMessageContext } from 'src/providers';

const AffirmInfo = () => {
  const { message, learnMoreUrl } = useAffirm();
  const { postMessage } = usePostMessageContext();
  const { modalType } = useModalSettingsContext();

  const trackLearnMoreClick = React.useCallback(() => {
    postMessage('affirmLearnMore', { modalType });
  }, [postMessage]);

  return (
    <div
      className='plandata-tab__affirm'
      id='affirm'
    >
      <div className='plandata-affirm__productprotect'>
        <span className='plandata-affirm__pill'>Product</span>
        <span className='plandata-affirm__plequal'>+</span>
        <span className='plandata-affirm__pill'>Protection</span>
        <span className='plandata-affirm__plequal affirm_equal_sign'>=</span>
      </div>

      <span className='plandata-affirm_ala'>
        As low as {message} with<img src='https://cdn-assets.affirm.com/images/black_logo-transparent_bg.svg' className='plandata-affirm_logo' alt='Affirm' />
        <a href={learnMoreUrl} target='_blank' className='plandata-affirm_learn' rel='noreferrer' onClick={trackLearnMoreClick}>Learn More</a>
      </span>
    </div>
  );
};

export default AffirmInfo;
